import classNames from 'classnames';
import { AVM_KEY_HC, AVM_KEY_RENTAL_HC } from 'legacy/appstore/constants';

import { getAvmTooltipText } from 'legacy/utils/avms';
import {
  dollarsFormatter,
  monthlyValueFormatter
} from 'legacy/utils/formatters';

import ValueConfidence from 'legacy/components/ValueConfidence';

import { PropertyExplorerValue as theme } from 'legacy/css-modules';

const PropertyExplorerAvmChart = ({
  selectedAvm,
  dataHcNames,
  selectedAvmKey,
  formattedAvmValue,
  isMonthlyValue,
  className
}) => {
  const confidenceLevel = selectedAvm.valuationSuitabilityScoreDesc;
  const sqFtValPercision = selectedAvm.valPerSqft < 10 ? 2 : 0;
  const tooltipText = getAvmTooltipText(selectedAvmKey, selectedAvm);
  return (
    <div className={classNames(theme['avm-chart'], className)}>
      <div
        className={classNames(
          'flex-row',
          theme['avm-chart-label-avm-container']
        )}
      >
        <div>
          <div
            data-hc-name={dataHcNames.value}
            className={theme['avm-chart-label-text-strong']}
          >
            {formattedAvmValue}
            {(selectedAvmKey === AVM_KEY_HC ||
              selectedAvmKey === AVM_KEY_RENTAL_HC) && (
              <ValueConfidence
                selectedAvmKey={selectedAvmKey}
                confidenceLevel={confidenceLevel}
                tooltipText={tooltipText}
              />
            )}
          </div>
          {selectedAvm.valPerSqft && (
            <div className={theme['avm-chart-label-text']}>
              {dollarsFormatter(selectedAvm.valPerSqft, sqFtValPercision)}
              /Sq.Ft.
            </div>
          )}
        </div>
      </div>
      <div className={theme['avm-chart-bar-labels']}>
        <span className={theme['avm-chart-bar-label']}>Low Estimate</span>
        <span className={theme['avm-chart-bar-label']} />
        <span className={theme['avm-chart-bar-label']}>High Estimate</span>
      </div>
      <div
        data-hc-name={dataHcNames.barChart}
        className={theme['avm-chart-bar']}
      />
      <div
        className={classNames(
          'flex-row',
          theme['avm-chart-label-avm-container-min-max']
        )}
      >
        <div>
          <div
            data-hc-name="valuation-bar-chart-range"
            className={theme['avm-chart-label-text-medium']}
          >
            {monthlyValueFormatter(selectedAvm.minVal, isMonthlyValue)}
          </div>
          {selectedAvm.minValPerSqft && (
            <div className={theme['avm-chart-label-text']}>
              {dollarsFormatter(selectedAvm.minValPerSqft, sqFtValPercision)}
              /Sq.Ft.
            </div>
          )}
        </div>
        <div>
          <div
            data-hc-name="valuation-bar-chart-range"
            className={theme['avm-chart-label-text-medium']}
          >
            {monthlyValueFormatter(selectedAvm.maxVal, isMonthlyValue)}
          </div>
          {selectedAvm.maxValPerSqft && (
            <div className={theme['avm-chart-label-text']}>
              {dollarsFormatter(selectedAvm.maxValPerSqft, sqFtValPercision)}
              /Sq.Ft.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyExplorerAvmChart;
